
<template>
    <div style="margin-left:50px;">
  
      <el-form style="display: flex;flex-wrap: wrap;">

          <el-form-item label="教师姓名:" style="display: flex;width: 33%;" >
              <el-select
                placeholder="请选择教师姓名"
                v-model="value1"
                style="width: 100%"
                clearable
                filterable
                remote
                :remote-method="searchTeachers"
                :loading="loading"
                >
                <el-option v-for="item in optionList1" :key="item.id"  :value="item.id"  :label="item.realname" ></el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="学生姓名:" style="display: flex;width: 33%;" >
              <el-select placeholder="请选择学生姓名" v-model="value2"  style="width: 100%"  clearable   filterable >
                  <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id"  :label="item.realname"   >  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="学生类型:" style="display: flex;width: 33%;">
              <el-select  placeholder="请选择学生类型"  v-model="value3" style="width: 100%"  clearable  filterable>
                  <el-option   v-for="item in optionList3" :key="item.id"  :value="item.id" :label="item.realname" >  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="上课方式:" style="display: flex;width: 33%;">
              <el-select  placeholder="请选择上课方式"  v-model="value4" style="width: 100%"  clearable  filterable>
                  <el-option   v-for="item in optionList4" :key="item.id"  :value="item.id" :label="item.realname" >  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="课程名称:" style="display: flex;width: 33%;">
              <el-select  placeholder="请选择课程名称"  v-model="value9" style="width: 100%"  clearable  filterable>
                  <el-option   v-for="item in optionList7" :key="item.id"  :value="item.id" :label="item.categoryName" >  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="上课日期:" style="display: flex;width: 33%;" >
            <el-date-picker style="width: 97%; margin-left: -6px;"  v-model="valuelist1"  value-format="yyyy-MM-dd"  type="date"  placeholder="请选择上课日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="操作时间:" style="display: flex;width: 33%;" >
            <el-date-picker  v-model="valuelist2" value-format="yyyy-MM-dd" type="daterange"  range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="操作方式:" style="display: flex;width: 33%;" >
              <el-select placeholder="请选择操作方式" v-model="value6"  style="width: 100%"  clearable   filterable >
                  <el-option   v-for="item in optionList6"  :key="item.id"  :value="item.id"  :label="item.realname"   >  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="操作人:" style="display: flex;width: 33%;" >
              <el-select placeholder="请选择操作人" v-model="value5"  style="width: 96%;margin-left: 14px;"  clearable   filterable >
                  <el-option   v-for="item in optionList5"  :key="item.id"  :value="item.id"  :label="item.realname"   >  </el-option>
               </el-select>
          </el-form-item>

          
          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
               <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
               <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
          </div>
  
      </el-form>
  
      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="650">

          <el-table-column prop="teacherName" label="教师姓名"></el-table-column>
          <el-table-column prop="studentName" label="学生姓名"></el-table-column>
          <el-table-column prop="classTypeName" label="学生类型"></el-table-column>
          <el-table-column prop="educationTypeName" label="上课方式"></el-table-column>
          <el-table-column prop="categoryName" label="课程名称"></el-table-column>
          <el-table-column prop="courseDate" label="上课日期"></el-table-column>
          <el-table-column  label="上课时间">
            <template slot-scope="scope">
             <div>{{scope.row.courseTimeOn}}-{{scope.row.courseEndTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="classHour" label="课时数"></el-table-column>
          <el-table-column prop="operateTime" label="操作时间" width="180"></el-table-column>
          <el-table-column prop="operateIdName" label="操作人"></el-table-column>
          <el-table-column prop="operateTypeName" label="操作方式"></el-table-column>
        </el-table>
  
  
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
        </el-pagination>
  
  
  
        <el-dialog title="详情" width="50%" :visible.sync="ShowDlong" :before-close="commitCler">
            <div style="display: flex;justify-content: space-between;margin-bottom: 50px;">
                <div>姓名：初始化姓名</div>
                <div style="">科目：初始科目</div>
                <div style="">职级：初始化职级</div>
                <div style="">招聘渠道：初始化招聘渠道</div>
                <div style="">内推人：初始化内推人</div>
                <div style="">boss来源负责人：初始化boss来源负责人</div>
                <div style="">入职时间：初始化入职时间</div>
            </div>
        </el-dialog>
    
  
  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";

import loadingUtils from "../utils/loading";
import { getTeachers_s } from "@/api/firstClassApi";

export default {

    data() {
        return {

            loading: false,


            value1:"",
            value2:"",
            value3:"",
            value4:"",
            value5:"",
            value6:"",
            value9:"",

            valuelist1: '',
            valuelist2: [],

            optionList7: [],


            optionList1: [],
            optionList2: [],
            optionList3: [
                { id: 1, realname: '规划' },
                { id: 2, realname: '线下' },
                { id: 3, realname: '纯补课' },
            ],
            optionList4: [
                { id: 1, realname: '网课' },
                { id: 2, realname: '上门' },
                { id: 3, realname: '门店' },
            ],
            optionList5: [],
            optionList6: [
                { id: 1, realname: '单排' },
                { id: 2, realname: '批量排' },
                { id: 3, realname: '单删' },
                { id: 4, realname: '批量删' },
                { id: 5, realname: '单修' },
                { id: 6, realname: '批量修' },
                { id: 7, realname: '单同步' },
                { id: 8, realname: '批量同步' },
                { id: 9, realname: '单撤销' },
                { id: 10, realname: '批量撤销' },
            ],

            
            requestParameters:{ pageNum:1, pageSize:10, total:0 },
            ShowDlong:false,
            dataList:[],
        }
    },

    mounted() {

        axios.get(`${apiBaseUrl}/schedule/categorylist`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.optionList7 = res.data.data;
        }).catch(error => {
          this.$message({
            message: error,
            type: "error"
          });
        });

        axios.get(`${apiBaseUrl}/scheduleOperateLog/findOperateStudent`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.optionList2 = res.data.data;
        }).catch(error => {
          this.$message({
            message: error,
            type: "error"
          });
        });

        axios.get(`${apiBaseUrl}/scheduleOperateLog/findOperateAdmin`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.optionList5 = res.data.data;
        }).catch(error => {
          this.$message({
            message: error,
            type: "error"
          });
        });

        // getTeachers_s().then((res) => {  this.optionList1 = res.data   })

        axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisListByName?name=`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.optionList1 = res.data.data;
        }).catch(error => {
          this.$message({
            message: error,
            type: "error"
          });
        });

        this.handleGetViewInit()
    },
    

   methods:{

        searchTeachers(query) {
            console.log(query)
            if (query !== '') {
                this.loading = true;
                axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisListByName?name=${query}`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                    this.optionList1 = res.data.data;
                }).catch(error => {
                    this.optionList1 = [];
                    this.$message({  message: error,  type: "error"  });
                })
                .finally(() => {
                    this.loading = false;
                });
            } else {
               axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisListByName?name=`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                 this.optionList1 = res.data.data;
               }).catch(error => {
                  this.$message({ message: error,  type: "error" });
               });
            }
        },


        handleGetViewInit(){
            axios.post(`${apiBaseUrl}/scheduleOperateLog/findPage`, {
                "pageNum":  this.requestParameters.pageNum,    //第几页
                "pageSize": this.requestParameters.pageSize,    //每页几条
                "teacherId": this.value1,    //老师id
                "studentId": this.value2,    //学生id
                "classType": this.value3,    //学生类型 1规划 2线下 3纯补课
                "educationType": this.value4,    //上课方式 1：网课；2：上门 3：门店
                "categoryId": this.value9,    //课程id
                "courseDate": this.valuelist1,    //上课日期
                "operateTimeStart": this.valuelist2 && this.valuelist2.length > 0 ? this.valuelist2[0] + " 00:00:00" : '',    //操作时间开始时间格式 yyyy-MM-dd HH:mm:ss
                "operateTimeEnd":this.valuelist2 && this.valuelist2.length > 0 ? this.valuelist2[1] + " 23:59:59" : '',    //操作时间结束时间格式 yyyy-MM-dd HH:mm:ss
                "operateId": this.value5,    //操作人
                "operateType": this.value6,    //操作类型(1单排、2批量排、3单删、4批量删、5单修、6批量修、7单同步、8批量同步、9单撤销、10批量撤销)

            },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res) => {
                let dats = res.data.data
                let records = res.data && res.data.data && res.data.data.records;
                if (res.data.code == 200) {
                    if(records && records.length > 0){
                        this.dataList = records;
                        this.requestParameters.total = dats.total
                    }else{
                        this.dataList = []
                        this.requestParameters.total = 0
                    }
                }else{
                   this.dataList = []
                   this.requestParameters.total = 0
                   this.$message.error(res.data.msg || res.data.message || "请求失败");
                }
            }).catch((error) => {
                this.dataList = []
                this.requestParameters.total = 0
                this.$message.error(error || "请求失败");
            })
        },

        clearBtns(){
            this.requestParameters.pageNum = 1
            this.requestParameters.pageSize = 10
            this.requestParameters.total = 0

            this.value1 = ""
            this.value2 = ""
            this.value3 = ""
            this.value4 = ""
            this.value5 = ""
            this.value6 = ""
            this.value9 = ''

            this.valuelist1 = ''
            this.valuelist2 = []

            axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisListByName?name=`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
              this.optionList1 = res.data.data;
            }).catch(error => {
               this.$message({ message: error,  type: "error" });
            });

            this.handleGetViewInit()
        },
        
        searchBtns(){
            this.requestParameters.pageNum = 1
            this.requestParameters.pageSize = 10
            this.requestParameters.total = 0
            this.handleGetViewInit()
        },
        
        handleClickView(){
            this.ShowDlong = true
        },

        handleSizeChange(size){
            this.requestParameters.pageSize = size
             this.handleGetViewInit()
        },

        handleCurrentChange(current){
            this.requestParameters.pageNum = current
             this.handleGetViewInit()
        },

        commitCler(){
            this.ShowDlong = false
        },
   }

}
 

</script>


<style lang="less" scoped>


</style>


// WEBPACK FOOTER //
// src/IntelligentScheduling/CourseSchedulingRecords.vue